module.exports = __webpack_public_path__ + "img/cases-brand-yincheng-lazyload-11.0acf8d09.jpg";